import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar"; // Import your Navbar
import Footer from "./components/Footer"; // Import your Footer
import Home from "./pages/Home";
import Login from "./pages/Login";
import Resources from "./pages/Resources";
import NotFound from "./pages/NotFound"; // Optional 404 page
import Dashboard from "./pages/Dashboard";
import StudentRegistration from "./pages/StudentRegistration";
import ViewRegistration from "./pages/ViewRegistration";
import ViewScoreboard from "./pages/ViewScoreboard";
import RegisterStudentPage from "./pages/home_component/RegisterStundentPage";
import Questions from "./pages/home_component/Questions";
import ResultPage from "./pages/home_component/ResultPage";

const App = () => {
  return (
    <div className="bg-yellow-100 pt-12">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/registration" element={<StudentRegistration />} />
          <Route path="/view-registration" element={<ViewRegistration />} />
          <Route path="/view-scoreboard/:studentId" element={<ViewScoreboard />} />
           <Route path="/register-student" element={<RegisterStudentPage />} />
           <Route path="/questions/:studentId" element={<Questions />} />
          <Route path="/result/:attemptId" element={<ResultPage />} />


      
        </Routes>
        <Footer />
      </Router>
    </div>
  );
};

export default App;
